import CampaignStatusValue from '@/Enums/CampaignManagement/CampaignStatus.enum';
import StatusChip from '@/components/StatusChip';
import { itemStatusChipPropMap } from '@/constants/itemStatus/chipProps';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { selectAllowCampaignApproval } from '@/store/selectors/me.selectors';
import { approveCampaign } from '@/store/slices/campaignManagementSlice';
import { Button } from '@mui/material';
import { memo, useCallback, useState } from 'react';
import { toast } from 'react-toastify';

interface IProps {
  campaignId: number;
  status: CampaignStatusValue;
  isEditMode: boolean;
}

const CampaignStatus = memo(({ campaignId, status, isEditMode }: IProps) => {
  const dispatch = useAppDispatch();
  const allowCampaignApproval = useAppSelector(selectAllowCampaignApproval);

  const [loading, setLoading] = useState(false);

  const handleApprove = useCallback(async () => {
    try {
      setLoading(true);
      // @ts-expect-error campaign management slice is not typed
      await dispatch(approveCampaign({ campaignId })).unwrap();
      toast.success('Campaign approved and activated successfully');
    } catch {
      toast.error('Failed to approve campaign');
    } finally {
      setLoading(false);
    }
  }, [campaignId, dispatch]);

  if (isEditMode && status === CampaignStatusValue.APPROVAL_REQUIRED && allowCampaignApproval) {
    return (
      <Button size='small' variant='outlined' onClick={handleApprove} disabled={loading}>
        Approve and activate
      </Button>
    );
  }

  return <StatusChip {...itemStatusChipPropMap[status]} />;
});

export default CampaignStatus;
